type Options = string;

interface Props {
  options: Options[];
  optionClicked: (value: string) => void;
  titleCaseOptions?: boolean;
  direction?: "up" | "down";
}

export default function Dropdown({
  options,
  optionClicked,
  titleCaseOptions,
  direction = "down",
}: Props) {
  function toTitleCase(str: string) {
    let strArr = str.toLowerCase().split(" ");
    for (var i = 0; i < strArr.length; i++) {
      strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
    }
    return strArr.join(" ");
  }

  return (
    <div
      className={`absolute right-0 z-10 max-h-3xl overflow-y-auto rounded-md border border-slate-200 bg-slate-300 py-sm ${
        direction === "up" ? "bottom-full mb-sm" : "top-full mt-sm"
      }`}
    >
      {options.map((option, index) => (
        <button
          key={index}
          className="block w-full px-md py-sm text-left hover:bg-slate-200"
          onMouseDown={() => optionClicked(option)}
        >
          {titleCaseOptions ? toTitleCase(option) : option}
        </button>
      ))}
    </div>
  );
}
